export default __webpack_public_path__ + "static/media/AutoCardSorting.b0f81cf1.jpg";